import React from 'react'
import LineStar from 'src/assets/images/doctor-profile/line-start.png'
import FilledStar from 'src/assets/images/doctor-profile/filled-star.png'

interface IProps {
  rating: number;
  className?: string;
  length?: number;
  size?: "small" | "medium" | "large" | "xlarge";
  containerClassName?: string;
  setRating?: (rating: number) => void;
}

const FavStarIcon = ({ rating = 0, className = '', length = 5, size = 'medium', containerClassName = '', setRating }: IProps) => {

    const sizeMap = {
        xsmall: 'w-[10px] h-[10px] lg:w-[0.5vw] lg:h-[0.5vw]',
        small: 'w-[13px] h-[13px] lg:w-[0.8vw] lg:h-[0.8vw]',
        medium: 'w-[15px] h-[15px] lg:w-[1vw] lg:h-[1vw]',
        large: 'w-[20px] h-[20px] lg:w-[1.2vw] lg:h-[1.2vw]',
        xlarge: 'w-[25px] h-[25px] lg:w-[1.4vw] lg:h-[1.4vw]',
    }

  return (
    <div className={`flex gap-0.5 lg:gap-[0.2vw] items-center ${containerClassName}`}>
        {[...Array(length)].map((_, v) => (
            <img src={rating >= v + 1 ? FilledStar : LineStar} alt="" className={` ${sizeMap[size]} ${setRating ? 'cursor-pointer hover:scale-125 transition-all' : ''} ${className}`} onClick={() => setRating?.(v + 1)} />
        ))}
    </div>
  )
}

export default FavStarIcon;